import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { capitalize } from 'lodash';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { Brand } from '../../../../../components/HotelDetailsOverlay/api/reviewService.js';
import { Flex, LabelXSmall } from '../../../../../primitives/index.js';
/**
 * @FIXME There's supposed to be a dedicated "brand"-field in the future
 */
const brandByNationality = {
  cz: Brand.inviacz,
  sk: Brand.inviask,
  hu: Brand.inviahu,
  pl: Brand.travelplanetpl
};
export const ReviewAttributes = ({
  review
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  const smDown = useBreakpointDown('sm');
  if (!review.traveledAs && !review.monthOfTravel && !review.yearOfTravel && !review.nationality) {
    return null;
  }
  const months = useMemo(() => t('amadeusRatingSection.reviewItem.months', {
    returnObjects: true
  }), [t]);
  const translationExist = property => {
    return Object.keys(t(`amadeusRatingSection.filters.options`, {
      returnObjects: true
    })).slice(1).includes(property);
  };
  return _jsxs(Flex, {
    direction: "row",
    spacing: "8px",
    divider: true,
    children: [review.traveledAs && _jsx(LabelXSmall, {
      color: "contentSecondary",
      children: translationExist(review.traveledAs) ? t(`amadeusRatingSection.filters.options.${review.traveledAs}`) : capitalize(review.traveledAs)
    }), Boolean(review.monthOfTravel && review.yearOfTravel) && _jsx(LabelXSmall, {
      color: "contentSecondary",
      children: t('amadeusRatingSection.reviewItem.travelDate', {
        month: Object.values(months)[review.monthOfTravel - 1],
        year: review.yearOfTravel
      })
    }), Boolean(review.nationality) && review.nationality in brandByNationality && _jsx(LabelXSmall, {
      color: "contentSecondary",
      children: smDown ? brandByNationality[review.nationality] : t('amadeusRatingSection.ratedOn', {
        brand: brandByNationality[review.nationality]
      })
    })]
  });
};